import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Storage } from '@ionic/storage'

import { NUBE_AWS, URL_SERVICIOS_AWS, URL_SERVICIOS_LOCALES, URL_SERVICIOS_LOCALES_IMPRESORA } from '../../config/url.servicio'

@Injectable()
export class DesperdiciosProvider {
  token:string
  urlPrintService:string

  constructor(public http: Http, private storage:Storage) {
      this.storage.get('token').then((val) => {
          this.token = val
      });

      this.storage.get('urlPrint').then((val) => {
          this.urlPrintService = val
      });
  }

  buscarGruposProductosParaCaja(companiaId) {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/proceso/gruposProductosParaCaja?companiaId=${companiaId}`)
          .map((data) => data.json())
  }

  buscarGruposProductosParaCajaComandas(companiaId) {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/proceso/gruposProductosParaCajaComandas?companiaId=${companiaId}`)
          .map((data) => data.json())
  }    

  buscarDesperdicios (text){
      const url = `${URL_SERVICIOS_LOCALES}/proceso/buscarCliente?datoBusca=${text}`;
      return this.http
          .get(url)
          .map(data => data.json()[0].map(item => {
              return {
                  display: item.nombreCliente,
                  value: item.clientesId
              }
          } ));
  }

 

  guardarDesperdicios (data){
    if(NUBE_AWS) {
        let url_servicio = URL_SERVICIOS_AWS;
        let values = {
          name: "almacenarDesperdicioDiario",
          parameters : {losDesperdicios: JSON.stringify(data)}
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option
        return this.http.post(`${url_servicio}/procedure`, values, options);
      } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + this.token
      })

      let options = new RequestOptions({
          headers: headers
      })
      
      const datos = {
          "losDesperdicios": JSON.stringify(data)
          }

      return this.http
          .post(`${url}/proceso/almacenarDesperdicioDiario`, datos, options)
        }
  } 
  
  buscarComandas(codigo:any) {
    if(NUBE_AWS) {
        let url_servicio = URL_SERVICIOS_AWS;
        let data = {
          name: "buscarComandas",
          parameters : {mesa: codigo}
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option
        return this.http.post(`${url_servicio}/procedure`, data, options);
      } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=buscarComandas&mesa=${codigo}`)
      .map((data) => data.json())
      }
    }

    buscarComandasDomicilios() {
        if(NUBE_AWS) {
            let url_servicio = URL_SERVICIOS_AWS;
            let data = {
              name: "buscarComandasDomicilios",
              parameters : {}
            }
            let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
            let options = new RequestOptions({ headers: headers }) // Create a request option
            return this.http.post(`${url_servicio}/procedure`, data, options);
          } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=buscarComandasDomicilios`)
      .map((data) => data.json())
          }
    }      

  buscarProductosParaDesperdiciosDiarios() {
    if(NUBE_AWS) {
        let url_servicio = URL_SERVICIOS_AWS;
        let data = {
          name: "productosParaDesperdiciosDiarios",
          parameters : {}
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option
        return this.http.post(`${url_servicio}/procedure`, data, options);
      } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })

      return this.http.get(`${url}/proceso/productosParaDesperdiciosDiarios`, options)
    }
    }
    
    productosParaDesperdiciosDiariosCompania(compania:any){
        if(NUBE_AWS) {
            let url_servicio = URL_SERVICIOS_AWS;
            let data = {
              name: "productosParaDesperdiciosDiariosCompania",
              parameters : {companiasId: JSON.stringify(compania)}
            }
            let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
            let options = new RequestOptions({ headers: headers }) // Create a request option
            return this.http.post(`${url_servicio}/procedure`, data, options);
          } else {
        let url = URL_SERVICIOS_LOCALES
        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        let options = new RequestOptions({
          headers: headers
        })
        const data = {
            "companiasId": JSON.stringify(compania)
            }        
  
        return this.http.get(`${url}/proceso/productosParaDesperdiciosDiariosCompania?companiasId=${data.companiasId}`)
        }
    }
}
                       


// WEBPACK FOOTER //
// ./src/providers/desperdicios/desperdicios.ts